import { serialize, parse } from "cookie";
 
import { TokenInfo } from "../models";
import { isEmpty } from "lodash";
import {jwtDecode} from "jwt-decode";
 

export function hasValidAuth(context:any = {}) {
  const { req = {}, res } = context;
  const cookies = parse(req.headers.cookie || "");
  const token = cookies.token;
  if (token) {
    setCookie(res, token,null);
    return true;
  }
  return false;
}

export function setCookie(res:any, token:any, expire:any) {
  res.setHeader(
    "Set-Cookie",
    serialize("token", token, { path: "/", expires: expire })
  );
}

export function getCookie(key:string) {
  if (typeof window === 'undefined') {
    return undefined;
  }
  var cookies = parse(window.document.cookie) || {};
  return cookies[key];
}

export function decodedToken(token: string):TokenInfo {
 var tokenInfo:TokenInfo = new TokenInfo();
  if(token){
   Object.assign(tokenInfo, jwtDecode(token) )
  }
  return tokenInfo;
}


export function getAuthToken(req) {
  const cookies = parse(req.headers.cookie || {});
  const token = cookies.token;
  return token;
}

export function getAuthTokenByReq(req) {
  const cookies =  req.cookies 
  const url =new URL(req.url)
  const params=url.searchParams
  const urlToken = (params)?params.get("token"):null
  const token = cookies.get("token")  || {}
  return token.value || urlToken;
}

export function getUserInfo(): TokenInfo {
  var token = getToken();
  var userInfo:any = decodedToken(token);
  return userInfo
}

export function getToken() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  var cookies = parse(window.document.cookie) || {};
  return cookies["token"];
}

export function getOrgId() {
  if (typeof window === 'undefined') {
    return null;
  }
  var cookies = parse(window.document.cookie) || {};
  return !isEmpty(cookies["orgId"])? cookies["orgId"]: localStorage.getItem("orgId");
}

export function setOrgId(orgId) {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem("orgId",orgId)
}

export function formatAuthProxyError(
  payload: unknown,
  apiHost = process.env.MD_API_HOST,
): string {
  if (typeof payload === "string" && payload.length > 0) {
    return payload;
  }
  if (!payload || typeof payload !== "object") {
    return "Request failed. Try again.";
  }
  const record = payload as Record<string, unknown>;
  if (typeof record.body === "string" && record.body.length > 0) {
    return record.body;
  }
  const err = record.error as Record<string, unknown> | undefined;
  if (!err) {
    return "Request failed. Try again.";
  }
  const code = (err.code || err.errno) as string | undefined;
  if (code === "ENOTFOUND" || code === "ECONNREFUSED" || code === "ETIMEDOUT") {
    const host =
      (typeof apiHost === "string" && apiHost.replace(/^https?:\/\//, "")) || "the API host";
    return `Cannot reach ${host}. Check your network or VPN, or point MD_API_HOST in .env.local at a reachable backend.`;
  }
  const message = err.message;
  return typeof message === "string" && message.length > 0 ? message : "Request failed. Try again.";
}
export function isOrgView(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  var cookies = parse(window.document.cookie) || {};
  return !isEmpty(cookies["orgId"]);
}

// getAuthToken<T>(request: TokenRequest): Promise<T> {
//   return HttpService.get('/v1/auth/token', {
//     method: 'GET',
//     data: request,
//   });
// }

// get<T>(url: string, options: any): Promise<T> {
//   return fetch(url, options).then((response) => {
//     if (!response.ok) {
//       throw new Error(response.statusText);
//     }
//     return response.json<T>();
//   });
// }

export function handleErrorResponse(req) {
  if (req.status === 401) {
    return {
      redirect: {
        destination: "/login",
        permanent: false,
      },
    };
  }

  return {};
}

export function redirect() {
  return {
    redirect: {
      destination: "/login",
      permanent: false,
    },
  };
}
